import {FaWrench, FaWater, FaSwimmingPool, FaTools, FaCheck, FaPhone} from 'react-icons/fa';
import {ServiceData} from '../types';

const createServiceData = (t: any): ServiceData => ({
    maintenance: {
        id: 'maintenance',
        slug: 'maintenance',
        title: t('servicesData.maintenance.title', 'Maintenance Industrielle'),
        subtitle: t('servicesData.maintenance.subtitle', 'Services de maintenance préventive et corrective pour garantir le fonctionnement optimal de vos équipements.'),
        description:
            t('servicesData.maintenance.description', `
              <p>Notre service de maintenance industrielle est conçu pour garantir le fonctionnement optimal de vos équipements et installations. Nous proposons des solutions sur mesure adaptées à vos besoins spécifiques.</p>
              <p>Avec notre expertise et notre engagement envers l'excellence, nous assurons la fiabilité et la longévité de vos systèmes industriels, réduisant ainsi les temps d'arrêt coûteux et optimisant votre productivité.</p>
            `),

        icon: <FaWrench/>,
        image: '/images/services/maintenance/maintenance.webp',
        features: [
            {
                title: t('servicesData.maintenance.features.f1.title', 'Contrats Personnalisés adaptés selon besoin du client'),
                description: t('servicesData.maintenance.features.f1.description', 'Solutions adaptées à vos besoins spécifiques et à votre budget'),
                icon: <FaCheck/>
            },
            {
                title: t('servicesData.maintenance.features.f2.title', 'Audit et Diagnostic'),
                description: t('servicesData.maintenance.features.f2.description', 'Évaluation complète de vos installations pour identifier les améliorations potentielles'),
                icon: <FaCheck/>
            },
            {
                title: t('servicesData.maintenance.features.f3.title', 'Mise en disposition des techniciens et ingénieurs qualifiés'),
                description: t('servicesData.maintenance.features.f3.description', 'Équipe de techniciens qualifiés prêts à intervenir'),
                icon: <FaCheck/>
            }
        ],
        info: [
            {
                text: t('servicesData.maintenance.info.f1.text', 'Service disponible 24/7 pour les urgences'),
                icon: <FaPhone/>
            },
            {
                text: t('servicesData.maintenance.info.f2.text', 'Équipe de techniciens certifiés'),
                icon: <FaCheck/>
            },
            {
                text: t('servicesData.maintenance.info.f3.text', 'Garantie sur toutes nos interventions'),
                icon: <FaCheck/>
            }
        ],
        subservices: [
            {
                id: 'contract-maintenance',
                title: t('servicesData.maintenance.subservices.contract-maintenance.title', 'Contrats Personnalisés adaptés selon besoin du client'),
                description: t('servicesData.maintenance.subservices.contract-maintenance.description', 'Programme d\'entretien régulier pour prévenir les pannes et prolonger la durée de vie de vos équipements industriels.'),
                link: '/services/maintenance/contract',
                image: '/images/services/maintenance/contract-maintenance.webp',
                imageFit: 'cover'
            },
            {
                id: 'audit-diagnostic',
                title: t('servicesData.maintenance.subservices.audit-diagnostic.title', 'Audit et Diagnostic'),
                description: t('servicesData.maintenance.subservices.audit-diagnostic.description', 'Évaluation complète de vos installations pour identifier les améliorations potentielles.'),
                link: '/services/maintenance/audit',
                image: '/images/services/maintenance/audit.webp'
            },
            {
                id: 'plumbing-works',
                title: t('servicesData.maintenance.subservices.plumbing-works.title', 'Travaux de Plomberie'),
                description: t('servicesData.maintenance.subservices.plumbing-works.description', 'Installation et réparation de réseaux d’eau potable, pose de chauffe-eau, robinets, WC, et entretien des installations pour sites résidentiels et professionnels.'),
                link: '/services/maintenance/plumbing',
                image: '/images/services/maintenance/plumbing-works.webp'
            },
            {
                id: 'electrical-works',
                title: t('servicesData.maintenance.subservices.electrical-works.title', 'Travaux d’Électricité'),
                description: t('servicesData.maintenance.subservices.electrical-works.description', 'Installations électriques complètes, mise en conformité des tableaux, éclairage, câblage industriel et résidentiel, et dépannage.'),
                link: '/services/maintenance/electrical',
                image: '/images/services/maintenance/electrical-works.webp'

            },
            {
                id: 'maintenance-works',
                title: t('servicesData.maintenance.subservices.maintenance-works.title', 'Mise en disposition des techniciens et ingénieurs qualifiés'),
                description: t('servicesData.maintenance.subservices.maintenance-works.description', 'Équipe de techniciens qualifiés prêts à intervenir'),
                link: '/services/maintenance/maintenance',
                image: '/images/services/maintenance/team-works.webp'
            }
        ]
    },
    waterTreatment: {
        id: 'waterTreatment',
        slug: 'water-treatment',
        title: t('servicesData.waterTreatment.title', 'Traitement des Eaux Usées et Assainissement'),
        subtitle: t('servicesData.waterTreatment.subtitle', 'Solutions de traitement des eaux usées écologiques et efficaces'),
        description: t('servicesData.waterTreatment.description', `
      <p>Nos solutions de traitement des eaux usées sont conçues pour répondre aux normes environnementales les plus strictes tout en offrant une efficacité maximale. Nous proposons des services complets, de la conception à la maintenance.</p>
      <p>Notre expertise dans ce domaine nous permet de créer des systèmes durables qui contribuent à la préservation des ressources en eau et à la protection de l'environnement.</p>
    `),
        icon: <FaWater/>,
        image: '/images/services/water-treatment/water-treatment.webp',
        features: [
            {
                title: t('servicesData.waterTreatment.features.f1.title', 'Conception de Stations de Traitement des Eaux Usées'),
                description: t('servicesData.waterTreatment.features.f1.description', 'Création de stations de traitement adaptées à vos besoins spécifiques'),
                icon: <FaCheck/>
            },
            {
                title: t('servicesData.waterTreatment.features.f2.title', 'Stations compactes (boues activées, biofiltres)'),
                description: t('servicesData.waterTreatment.features.f2.description', 'Solutions compactes pour zones limitées'),
                icon: <FaCheck/>
            },
            {
                title: t('servicesData.waterTreatment.features.f3.title', 'Stations SBR (Sequencing Batch Reactor (Traitement séquentiel dans une seule cuve)'),
                description: t('servicesData.waterTreatment.features.f3.description', 'Systèmes adaptés aux besoins industriels'),
                icon: <FaCheck/>
            },
            {
                title: t('servicesData.waterTreatment.features.f4.title', 'Fosse de Relevage eau usée'),
                description: t('servicesData.waterTreatment.features.f4.description', 'Fourniture, Installation et Maintenance de fosse de relevage'),
                icon: <FaCheck/>
            }
        ],
        info: [
            {
                text: t('servicesData.waterTreatment.info.f1.text', 'Solutions conformes aux normes environnementales'),
                icon: <FaCheck/>
            },
            {
                text: t('servicesData.waterTreatment.info.f2.text', 'Technologies éco-responsables'),
                icon: <FaCheck/>
            },
            {
                text: t('servicesData.waterTreatment.info.f3.text', 'Maintenance préventive incluse'),
                icon: <FaCheck/>
            }
        ],
        subservices: [
            {
                id: 'conception-stations',
                title: t('servicesData.waterTreatment.subservices.conception-stations.title', 'Dimensionnement de Stations d\'épuration'),
                description: t('servicesData.waterTreatment.subservices.conception-stations.description', 'Solutions adaptées à vos besoins spécifiques'),
                link: '/services/water-treatment/dimensionnement-stations',
                image: '/images/services/water-treatment/dimensionnement-de-stations.webp'
            },
            {
                id: 'relevage-eau-usee',
                title: t('servicesData.waterTreatment.subservices.relevage-eau-usee.title', 'Fosse de Relevage eau usée'),
                description: t('servicesData.waterTreatment.subservices.relevage-eau-usee.description', 'Fourniture, Installation et Maintenance de fosse de relevage'),
                link: '/services/water-treatment/relevage-eau-usée',
                image: '/images/services/water-treatment/fosse-de-Relevage.webp',
                imageFit: 'fill'
            },
            //Systèmes d’Irrigation
            {
                id: 'irrigation-systems',
                title: t('servicesData.waterTreatment.subservices.irrigation-systems.title', 'Systèmes d’Irrigation'),
                description: t('servicesData.waterTreatment.subservices.irrigation-systems.description', 'Solutions adaptées à vos besoins spécifiques'),
                link: '/services/water-treatment/irrigation-systems',
                image: '/images/services/water-treatment/irrigation-systems.webp'
            },
            //Nettoyage Haute Pression
            {
                id: 'nettoyage-haute-pression',
                title: t('servicesData.waterTreatment.subservices.nettoyage-haute-pression.title', 'Nettoyage Haute Pression'),
                description: t('servicesData.waterTreatment.subservices.nettoyage-haute-pression.description', 'Solutions adaptées à vos besoins spécifiques'),
                link: '/services/water-treatment/nettoyage-haute-pression',
                image: '/images/services/water-treatment/nettoyage-haute-pression.webp',
                imageFit: 'cover'

            },
            {
                id: 'desinfection-degazage',
                title: t('servicesData.waterTreatment.subservices.desinfection-degazage.title', 'Désinfection et Dégazage'),
                description: t('servicesData.waterTreatment.subservices.desinfection-degazage.description', 'Solutions adaptées à vos besoins spécifiques'),
                link: '/services/water-treatment/desinfection-degazage',
                image: '/images/services/water-treatment/desinfection-degazage.webp',
                imageFit: 'fill'
            },
            {
                id: 'entretien-locaux-techniques',
                title: t('servicesData.waterTreatment.subservices.entretien-locaux-techniques.title', 'Ramonage et nettoyage cryogénique'),
                description: t('servicesData.waterTreatment.subservices.entretien-locaux-techniques.description', 'Solutions adaptées à vos besoins spécifiques'),
                link: '/services/water-treatment/nettoyage-cryogenique-industriel',
                image: '/images/services/water-treatment/nettoyage-cryogenique-industriel.webp',
                imageFit: 'fill'
            },
            {
                id: 'assainissement-reseaux',
                title: t('servicesData.waterTreatment.subservices.assainissement-reseaux.title', 'Assainissement de réseaux et curage de canalisations'),
                description: t('servicesData.waterTreatment.subservices.assainissement-reseaux.description', 'Solutions adaptées à vos besoins spécifiques'),
                link: '/services/water-treatment/assainissement-reseaux',
                image: '/images/services/water-treatment/curage-des-canalisation.webp',
                imageFit: 'fill'
            }
        ]
    },
    pools: {
        id: 'pools',
        slug: 'pools',
        title: t('servicesData.pools.title', 'Fourniture des equipements des piscines et installation'),
        subtitle: t('servicesData.pools.subtitle', 'Conception et installation de piscines de qualité supérieure'),
        description: t('servicesData.pools.description', `
      <p>Notre service d'installation de piscines offre des solutions complètes pour les particuliers et les professionnels. De la conception initiale à l'installation finale, nous assurons un service de qualité supérieure.</p>
      <p>Nous utilisons des matériaux de première qualité et les dernières technologies pour créer des piscines durables, esthétiques et faciles à entretenir.</p>
    `),
        icon: <FaSwimmingPool/>,
        image: '/images/services/pools/pools.webp',
        features: [
            {
                title: t('servicesData.pools.features.f1.title', 'Conception Personnalisée'),
                description: t('servicesData.pools.features.f1.description', 'Design sur mesure selon vos envies et contraintes d\'espace'),
                icon: <FaCheck/>
            },
            {
                title: t('servicesData.pools.features.f2.title', 'Installation Complète'),
                description: t('servicesData.pools.features.f2.description', 'Gestion de toutes les étapes, du terrassement à la mise en eau'),
                icon: <FaCheck/>
            },
            {
                title: t('servicesData.pools.features.f3.title', 'Équipements Techniques'),
                description: t('servicesData.pools.features.f3.description', 'Installation de pompes, filtres, systèmes de chauffage et d\'éclairage'),
                icon: <FaCheck/>
            },
            {
                title: t('servicesData.pools.features.f4.title', 'Entretien'),
                description: t('servicesData.pools.features.f4.description', 'Services d\'entretien pour maintenir la qualité de votre piscine'),
                icon: <FaCheck/>
            }
        ],
        info: [
            {
                text: t('servicesData.pools.info.f1.text', 'Matériaux de qualité supérieure'),
                icon: <FaCheck/>
            },
            {
                text: t('servicesData.pools.info.f2.text', 'Respect des délais et budget'),
                icon: <FaCheck/>
            },
            {
                text: t('servicesData.pools.info.f3.text', 'Garantie sur installation'),
                icon: <FaCheck/>
            }
        ],
        subservices: [
            {
                id: 'pool-materials',
                title: t('servicesData.pools.subservices.pool-materials.title', 'Fourniture des materiels'),
                description: t('servicesData.pools.subservices.pool-materials.description', 'Fourniture des materiels des piscines et instalation.'),
                link: '/services/pools/materials',
                image: '/images/services/pools/pools-materials.webp',
                imageFit: 'fill'
            },
            {
                id: 'pool-products',
                title: t('servicesData.pools.subservices.pool-products.title', 'Fourniture des produits de traitements'),
                description: t('servicesData.pools.subservices.pool-products.description', 'Fourniture des produits de traitements des piscines.'),
                link: '/services/pools/products',
                image: '/images/services/pools/pool-products.webp',
                imageFit: 'cover'
            },
            {
                id: 'pool-chemicals',
                title: t('servicesData.pools.subservices.pool-chemicals.title', 'Fourniture des produits de nettoyage'),
                description: t('servicesData.pools.subservices.pool-chemicals.description', 'Fourniture des produits nettoyages des piscines.'),
                link: '/services/pools/nettoyage',
                image: '/images/services/pools/pool-nettoyage-products.webp',
                imageFit: 'fill'
            },
            {
                id: 'pool-installation',
                title: t('servicesData.pools.subservices.pool-installation.title', 'Installation des locaux techniques'),
                description: t('servicesData.pools.subservices.pool-installation.description', 'Installation des locaux techniques des piscines.'),
                link: '/services/pools/installation',
                image: '/images/services/pools/pool-installation.webp',
                imageFit: 'cover'
            }
        ]
    },
    renovation: {
        id: 'renovation',
        slug: 'renovation',
        title: t('servicesData.renovation.title', 'Rénovation des bâtiments industriels et habitation'),
        subtitle: t('servicesData.renovation.subtitle', 'Modernisation et mise à niveau des installations existantes'),
        description: t('servicesData.renovation.description', `
      <p>Nos services de rénovation industrielle visent à moderniser vos installations pour améliorer leur efficacité et leur conformité aux normes actuelles. Nous gérons des projets de toutes tailles avec précision et expertise.</p>
      <p>Que ce soit pour une mise à niveau complète ou des améliorations ciblées, nous minimisons les interruptions d'activité tout en maximisant les résultats.</p>
    `),
        icon: <FaTools/>,
        image: '/images/services/renovation/renovation.webp',
        features: [
            {
                title: t('servicesData.renovation.features.f1.title', 'Modernisation'),
                description: t('servicesData.renovation.features.f1.description', 'Mise à jour des équipements obsolètes avec des technologies modernes'),
                icon: <FaCheck/>
            },
            {
                title: t('servicesData.renovation.features.f2.title', 'Conformité'),
                description: t('servicesData.renovation.features.f2.description', 'Adaptation aux normes de sécurité et environnementales actuelles'),
                icon: <FaCheck/>
            },
            {
                title: t('servicesData.renovation.features.f3.title', 'Optimisation'),
                description: t('servicesData.renovation.features.f3.description', 'Amélioration des performances et réduction des coûts d\'exploitation'),
                icon: <FaCheck/>
            },
            {
                title: t('servicesData.renovation.features.f4.title', 'Gestion de Projet'),
                description: t('servicesData.renovation.features.f4.description', 'Coordination complète pour minimiser les interruptions d\'activité'),
                icon: <FaCheck/>
            }
        ],
        info: [
            {
                text: t('servicesData.renovation.info.f1.text', 'Solutions clé en main'),
                icon: <FaCheck/>
            },
            {
                text: t('servicesData.renovation.info.f2.text', 'Respect des délais serrés'),
                icon: <FaCheck/>
            },
            {
                text: 'Budget maîtrisé',
                icon: <FaCheck/>
            }
        ],
        subservices: [
            {
                id: 'building-maintenance',
                title: t('servicesData.renovation.subservices.building-maintenance.title', 'Entretien des Bâtiments'),
                description: t('servicesData.renovation.subservices.building-maintenance.description', 'Peinture, Nettoyage, Reparation, Jardinage.'),
                link: '/services/entretien/batiment',
                image: '/images/services/renovation/entretien-batiment.webp',
                imageFit: 'fill'
            },
            {
                id: 'construction',
                title: t('servicesData.renovation.subservices.construction.title', 'Construction'),
                description: t('servicesData.renovation.subservices.construction.description', 'construction des locaux techniques, charpon metaliques, isolation.'),
                link: '/services/construction',
                image: '/images/services/renovation/construction.webp',
                imageFit: 'fill'
            }, {
                id: 'renovation',
                title: t('servicesData.renovation.subservices.renovation.title', 'Rénovation & Mise à Niveau'),
                description: t('servicesData.renovation.subservices.renovation.description', 'Modernisation des réseaux d’eau, électricité, assainissement, remplacement de composants obsolètes, et optimisation énergétique.'),
                link: '/services/renovation/update',
                image: '/images/services/renovation/renovation-update.webp',
                imageFit: 'fill'
            }
        ]
    },
    industrialSupply: {
        id: 'industrialSupply',
        slug: 'industrial-supply',
        title: t('servicesData.industrialSupply.title', 'Fourniture Industrielle'),
        subtitle: t('servicesData.industrialSupply.subtitle', 'Fourniture de matériel et équipements industriels'),
        description: t('servicesData.industrialSupply.description', `
      <p>Nous fournissons une large gamme de produits industriels : outillage, EPI, pièces de rechange, raccords, tuyauterie, produits de nettoyage et maintenance.</p>
      <p>Notre service de livraison rapide partout au Maroc assure que vous recevez vos équipements dans les plus brefs délais.</p>
    `),
        icon: <FaTools/>,
        image: '/images/services/industrial-supply/industrial-supply.webp',
        features: [
            {
                title: t('servicesData.industrialSupply.features.f1.title', 'Large Gamme de Produits'),
                description: t('servicesData.industrialSupply.features.f1.description', 'Outillage, EPI, pièces détachées et plus encore'),
                icon: <FaCheck/>
            },
            {
                title: t('servicesData.industrialSupply.features.f2.title', 'Livraison Rapide'),
                description: t('servicesData.industrialSupply.features.f2.description', 'Service de livraison partout au Maroc'),
                icon: <FaCheck/>
            },
            {
                title: t('servicesData.industrialSupply.features.f3.title', 'Produits de Qualité'),
                description: t('servicesData.industrialSupply.features.f3.description', 'Équipements testés et approuvés pour un usage industriel'),
                icon: <FaCheck/>
            }
        ],
        info: [
            {
                text: t('servicesData.industrialSupply.info.f1.text', 'Stock disponible en permanence'),
                icon: <FaCheck/>
            },
            {
                text: t('servicesData.industrialSupply.info.f2.text', 'Conseils d’experts pour vos achats'),
                icon: <FaCheck/>
            }
        ],
        subservices: [
            {
                id: 'industrial-supply-mechanical',
                title: t('servicesData.industrialSupply.subservices.industrial-supply-mechanical.title', 'Articles de mécanique industrielle'),
                description: t('servicesData.industrialSupply.subservices.industrial-supply-mechanical.description', 'Roulements (à billes, à rouleaux…), courroies et chaînes de transmission, paliers et supports, Joints toriques, Accouplements, Vérins mécaniques, Poulies, engrenages, Lubrifiants industriels.'),
                link: '/services/industrial-supply/mecanique-industrielle',
                image: '/images/services/industrial-supply/mecanique-industrielle.webp',
                imageFit: 'contain'
            },
            {
                id: 'industrial-supply-electrical',
                title: t('servicesData.industrialSupply.subservices.industrial-supply-electrical.title', 'Articles d\'électricité industrielle'),
                description: t('servicesData.industrialSupply.subservices.industrial-supply-electrical.description', 'Câbles électriques (cuivre, multiconducteurs, etc.)\n' +
                    'Goulottes et gaines\n' +
                    'Disjoncteurs, contacteurs, relais\n' +
                    'Boítiers de dérivation, coffrets\n' +
                    'Éclairages LED industriels\n' +
                    'Prises et interrupteurs étanches\n' +
                    'Armoires électriques\n' +
                    'Transformateurs, alimentations'),
                link: '/services/industrial-supply/electrical',
                image: '/images/services/industrial-supply/electrical.webp',
                imageFit: 'fill'
            },
            {
                id: 'industrial-supply-automation',
                title: t('servicesData.industrialSupply.subservices.industrial-supply-automation.title', 'Articles d’automatisme'),
                description: t('servicesData.industrialSupply.subservices.industrial-supply-automation.description', 'Automates programmables (PLC)\n' +
                    'Variateurs de vitesse\n' +
                    'Capteurs (inductifs, optiques, de température…)\n' +
                    'Relais temporisés\n' +
                    'IHM (écrans de supervision)\n' +
                    'Boutons-poussoirs, voyants\n' +
                    'Modules d’extension\n' +
                    'Barrières immatérielles de sécurité'),
                link: '/services/industrial-supply/automatism',
                image: '/images/services/industrial-supply/automatisme.webp',
                imageFit: 'contain'
            },
            {
                id: 'industrial-supply-outillage',
                title: t('servicesData.industrialSupply.subservices.industrial-supply-outillage.title', 'Articles outillage professionnel'),
                description: t('servicesData.industrialSupply.subservices.industrial-supply-outillage.description', 'Perceuses, meuleuses, visseuses (électroportatif)\n' +
                    'Clés dynamométriques\n' +
                    'Pinces, tournevis, marteaux\n' +
                    'Douilles et cliquets\n' +
                    'Multimètres\n' +
                    'Boîtes à outils complètes\n' +
                    'Outils de serrage et de coupe\n' +
                    'Équipements de soudure'),
                link: '/services/industrial-supply/professional-tools',
                image: '/images/services/industrial-supply/industrial-supply-professional-tools.webp',
                imageFit: 'fill'
            },
            {
                id: 'industrial-supply-epi',
                title: t('servicesData.industrialSupply.subservices.industrial-supply-epi.title', 'Équipements de protection individuelle (EPI)'),
                description: t('servicesData.industrialSupply.subservices.industrial-supply-epi.description', 'Casques, bouchons d’oreilles, lunettes\n' +
                    'Gants (coupure, chimique, manutention)\n' +
                    'Chaussures de sécurité\n' +
                    'Vêtements haute visibilité, combinaisons\n' +
                    'Harnais, masques respiratoires'),
                link: '/services/industrial-supply/epi',
                image: '/images/services/industrial-supply/industrial-protection-tools.webp',
                imageFit: 'contain'
            },
            {
                id: 'industrial-supply-pump',
                title: t('servicesData.industrialSupply.subservices.industrial-supply-pump.title', 'Pompes, vannes et raccords'),
                description: t('servicesData.industrialSupply.subservices.industrial-supply-pump.description', 'Pompes centrifuges, submersibles, péristaltiques\n' +
                    'Vannes à boisseau, papillon, clapets anti-retour\n' +
                    'Raccords en laiton, PVC, inox\n' +
                    'Tuyaux flexibles industriels\n' +
                    'Collecteurs et systèmes de distribution'),
                link: '/services/industrial-supply/pipes',
                image: '/images/services/industrial-supply/pipes.webp',
                imageFit: 'contain'
            }


        ]
    },
    airCompressors: {
        id: 'airCompressors',
        slug: 'air-compressors',
        title: t('servicesData.airCompressors.title', 'Compresseurs d\'Air'),
        subtitle: t('servicesData.airCompressors.subtitle', 'Fourniture et maintenance de compresseurs d\'air'),
        description: t('servicesData.airCompressors.description', `
      <p>Nos services de compresseurs d'air sont conçus pour répondre aux besoins de vos installations industrielles. Nous proposons des solutions complètes, de la fourniture à la maintenance.</p>
      <p>Notre équipe utilise des équipements de pointe pour assurer un service rapide et efficace.</p>
    `),
        icon: <FaTools/>,
        image: '/images/services/compressor/compresseur-service.webp',
        features: [
            {
                title: t('servicesData.airCompressors.features.f1.title', 'Fourniture de Compresseurs'),
                description: t('servicesData.airCompressors.features.f1.description', 'Vente de compresseurs d\'air de toutes puissances'),
                icon: <FaCheck/>
            },
            {
                title: t('servicesData.airCompressors.features.f2.title', 'Installation et Maintenance'),
                description: t('servicesData.airCompressors.features.f2.description', 'Installation et entretien régulier pour garantir le bon fonctionnement'),
                icon: <FaCheck/>
            },
            {
                title: t('servicesData.airCompressors.features.f3.title', 'Réparation et Dépannage'),
                description: t('servicesData.airCompressors.features.f3.description', 'Intervention rapide en cas de panne ou dysfonctionnement'),
                icon: <FaCheck/>
            }
        ],
        info: [
            {
                text: t('servicesData.airCompressors.info.f1.text', 'Équipements de pointe'),
                icon: <FaCheck/>
            },
            {
                text: t('servicesData.airCompressors.info.f2.text', 'Service rapide'),
                icon: <FaCheck/>
            }
        ],
        subservices: [
            {
                id: 'air-compressor-supply-repair',
                title: t('servicesData.airCompressors.subservices.air-compressor-supply-repair.title', 'Fourniture et Réparation de Compresseurs d’Air'),
                description: t('servicesData.airCompressors.subservices.air-compressor-supply-repair.description', 'Vente, installation, entretien et réparation de compresseurs d’air comprimé de toutes puissances, service rapide pour éviter l’arrêt de production.'),
                link: '/services/air-compressors/supply-repair',
                image: '/images/services/compressor/reparation.webp',
                imageFit: 'fill'
            }
        ],
        products: [
            {
                id: 'catinno-MCR-7-2',
                title: t('servicesData.airCompressors.products.catinno-MCR-7-2.title', 'COMPRESSEUR À VIS LUBRIFIÉ 7.5KW 10 HP'),
                description: t('servicesData.airCompressors.products.catinno-MCR-7-2.description', 'Le compresseur à vis lubrifié 7.5 kw à vitesse fixe Marque CATINNO peut atteindre leur capacité maximale et il est donc parfaits pour les situations dans lesquelles un flux d’air est stable.\n' +
                    '\n' +
                    'Fonctionne à un régime constant, sauf si on l’éteint. Au lieu de voir la soupape d’admission s’ouvrir et se fermer pour fournir ou couper le flux d’air nécessaire, elle s’incline en fonction du moment où l’air est ou non nécessaire.'),
                image: '/images/services/compressor/Catinno-MCR-7-2-768x727.webp',
                link: '/services/air-compressors/products/Catinno-MCR-7-2'
            },
            {
                id: 'CFD-68',
                title: t('servicesData.airCompressors.products.CFD-68.title', 'SÉCHEUR PAR RÉFRIGÉRATION CFD 68'),
                description: t('servicesData.airCompressors.products.CFD-68.description', 'Purge des condensats intégrée\n' +
                    'Commande par système électronique\n' +
                    'Débit : 6.5 m3/min\n' +
                    'Economie d’énergie'),
                image: '/images/services/compressor/Secheur-frigorifique-pour-compresseur-37-kw-Catinno.webp',
                link: '/services/air-compressors/products/Catinno-CFD-68'
            },
            {
                id: 'catinno-RC-2',
                title: t('servicesData.airCompressors.products.catinno-RC-2.title', 'RÉSERVOIR D’AIR COMPRIMÉ'),
                description: t('servicesData.airCompressors.products.catinno-RC-2.description', 'Réservoirs d’air comprimé galvanisés (100 à 2000 L, 10 à 16 bars), ' +
                    'certifiés par un bureau homologué du ministère marocain des énergies et des mines. ' +
                    'Fabriqués selon les normes internationales, ils assurent un stockage fiable, réduisent les pics de pression et protègent le compresseur. ' +
                    'Fournis avec certificat d’épreuve, dossier technique et 1 an de garantie. Un entretien régulier est essentiel pour garantir sécurité et performance.'),
                image: '/images/services/compressor/Reservoirs-dair-comprime-768x768.webp',
                link: '/services/air-compressors/products/Catinno-RC-2'
            },
            {
                id: 'catinno-filter-2',
                title: t('servicesData.airCompressors.products.catinno-filter-2.title', 'FILTRE D’AIR COMPRIMÉ'),
                description: t('servicesData.airCompressors.products.catinno-filter-2.description', 'Le filtre à air est primordial dans la qualité de l’air entrant. En fonction de l’ambiance, il se colmate plus ou moins rapidement : cette perte de charge implique une surconsommation électrique.\n' +
                    '\n' +
                    'Une gamme étendue de cartouches filtrantes est disponible pour répondre aux exigences spécifiques des compresseurs et des pompes à vide. Les degrés de filtration sont adaptés à l’utilisation prévue.\n' +
                    '\n' +
                    'Les filtres Air sont soumis aux normes de qualité les plus sévères et sont régulièrement testés afin de garantir leur bon fonctionnement pour l’application à laquelle ils sont destinés.'),
                image: '/images/services/compressor/AIR-FILTER-768x768.webp',
                link: '/services/air-compressors/products/Catinno-filter-2'

            },
            {
                id: 'catinno-mam-pieces',
                title: t('servicesData.airCompressors.products.catinno-mam-pieces.title', 'MAM-PIÈCES D\'AFFICHAGE DE CONTRÔLEUR'),
                description: t('servicesData.airCompressors.products.catinno-mam-pieces.description', 'Système de contrôle intelligent du compresseur\n' +
                    'Le système offre un affichage d\'état performant, avec alarmes, instructions de maintenance prédictive et sécurité intégrée. ' +
                    'Il centralise la détection et le contrôle sur une interface en anglais. Grâce à un microprocesseur haute technologie, il ajuste automatiquement la charge d\'air selon les besoins. ' +
                    'Il se distingue par sa stabilité, sa conception normalisée, ses capacités avancées de diagnostic et de protection, ainsi qu\'une interface de câblage claire et facile à entretenir.'),
                image: '/images/services/compressor/MAM-768x768.webp',
                link: '/services/air-compressors/products/Catinno-mam-piences'
            }
        ]
    }
});

export default createServiceData;
